module.exports = __webpack_public_path__ + "static/img/clothing_12.7b20e0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_12.png
// module id = xoSQ
// module chunks = 0